import { useEffect, useRef, useState } from 'react';

let razorpayPromise: Promise<boolean> | null = null;

const loadRazorpayScript = (): Promise<boolean> => {
  if ((window as any).Razorpay) return Promise.resolve(true);

  if (razorpayPromise) return razorpayPromise;

  razorpayPromise = new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;

    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      razorpayPromise = null;
      resolve(false);
    };

    document.body.appendChild(script);
  });

  return razorpayPromise;
};

/**
 * Loads Razorpay's checkout script once `enabled` turns true. Dialogs pass
 * their `open` state: they are rendered closed on many pages (every locked job
 * card, the employer layout), and loading on mount pulled Razorpay and its
 * chunks into pages where nobody is paying.
 */
const useRazorpay = (enabled = true) => {
  const [isLoaded, setIsLoaded] = useState<boolean>(!!(window as any).Razorpay);
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!enabled) return undefined;
    mountedRef.current = true;

    loadRazorpayScript().then((loaded) => {
      if (mountedRef.current) {
        setIsLoaded(loaded);
      }
    });

    return () => {
      mountedRef.current = false;
    };
  }, [enabled]);

  return isLoaded;
};

export default useRazorpay;
